import { _ } from '@ngx-translate/core';

export const DELETE_AUTH_USER_CONFIRMATION_TEXT = _(
  'components.deleteAuthUserDialog.constants.deleteAuthUserConfirmationText',
);
